const White = 'white'
const Gray = 'gray'
const NoPayoff = 'no-payoff'
const Color = 'color'

export default { White, Gray, NoPayoff, Color }
